module.exports = __webpack_public_path__ + "static/media/map-background.c21df147.jpg";